import React from 'react';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';

const DTSendMacroGiveFreeshipCodeNode = () => {
  return <DTCopyTextSendMacroView buttonText={'EXECUTE ACTION'} onNextButtonClick={() => {}} hideCopyText={false} />;
};

export default DTSendMacroGiveFreeshipCodeNode;
